import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const FastLaneSection = () => {
  const features = [
  {
    id: 'feature_express',
    icon: 'TruckIcon',
    title: 'Express Air Freight',
    description: 'Fast international shipping'
  },
  {
    id: 'feature_door',
    icon: 'HomeModernIcon',
    title: 'Door-to-Door Courier',
    description: 'Complete delivery service'
  }];


  return (
    <section className="py-24 lg:pt-40 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="reveal">
            <h2 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6 leading-tight">
              Your Fast Lane to <span className="text-primary">Secure and Swift</span> Deliveries
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Streamlined logistics solutions for timely and hassle-free cargo transport across the globe. We handle everything from production to your doorstep.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Link
                href="/get-a-quote"
                className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold rounded-full px-8 py-4 hover:bg-primary/90 transition-all">
                
                Deliver Now
                <Icon name="TruckIcon" size={20} />
              </Link>
              <Link
                href="/contact"
                className="inline-flex items-center justify-center gap-2 bg-white border-2 border-gray-300 text-foreground font-semibold rounded-full px-8 py-4 hover:bg-gray-50 transition-all">
                
                Calculate Cost
                <Icon name="CalculatorIcon" size={20} />
              </Link>
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6">
              {features.map((feature) =>
              <div key={feature.id} className="flex items-start gap-3">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={feature.icon as any} size={24} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">{feature.title}</h3>
                    <p className="text-sm text-muted-foreground">{feature.description}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right Image */}
          <div className="reveal relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-8 border-primary/20">
              <AppImage
                src="/assets/images/Screenshot_2026-02-13_at_5.32.26_PM-1771033740884.png"
                alt="Premium shipping container showcasing quality construction and delivery service"
                className="w-full h-[600px] object-cover" />
              
              
              {/* Play Button Overlay */}
              <button className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform">
                <Icon name="PlayIcon" size={32} className="text-primary ml-1" />
              </button>

              {/* Fastrack Badge */}
              <div className="absolute bottom-8 right-8 bg-primary/90 backdrop-blur-sm text-primary-foreground font-bold rounded-xl px-6 py-4">
                <Icon name="BoltIcon" size={24} />
                <span className="text-lg">fastrack</span>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>);

};

export default FastLaneSection;